export default {
  month: {
    1: "tháng giêng",
    2: "tháng hai",
    3: "tháng ba",
    4: "tháng tư",
    5: "tháng năm",
    6: "tháng sáu",
    7: "tháng bảy",
    8: "tháng tám",
    9: "tháng chín",
    10: "tháng mười",
    11: "tháng mười một",
    12: "tháng mười hai",
  },
  weekDay: {
    short: {
      2: "H",
      3: "B",
      4: "T",
      5: "N",
      6: "S",
      7: "B",
      1: "C",
    },
    full: {
      2: "Thứ hai",
      3: "Thứ ba",
      4: "Thứ tư",
      5: "Thứ năm",
      6: "Thứ sáu",
      7: "Thứ bảy",
      1: "Chủ nhật",
    },
  },
};
// export { "test" : "ok"}
